// src/store/modules/queue.js
import http from '@/helpers/http'

export default {
    namespaced: true,
    state: {
        patients: [],
        hasNew: false,
        queueCount: 0
    },
    mutations: {
        setPatients(state, patients) {
            state.patients = patients
            state.hasNew = patients.some(p => !p.called_at)
            state.queueCount = patients.filter(p => !p.called_at).length
        }
    },
    actions: {
        async fetchPatients({ commit, rootState }) {
            const idPlace = rootState.auth.place?.id_place
            const idTerminal = rootState.auth.terminal?.id_terminal
            if (!idPlace || !idTerminal) {
                commit('setPatients', [])
                return
            }

            const response = await http.get(`/places/${idPlace}/queue-arrivals/${idTerminal}`)
            commit('setPatients', response.data)
        }
    }
}